<script>
import { EventBus, Topics, Types } from '@/event-bus'

export default {
  name: 'EpanetRangeSimulacao',
  data() {
    return {
      initialDate: null,
      finalDate: null,
    }
  },
  beforeMount() {
    this.finalDate = new Date()

    this.initialDate = new Date(this.finalDate)
    this.initialDate.setHours(this.initialDate.getHours() - 12)
  },
  methods: {
    async emitRange() {
      if (!this.finalDate) {
        EventBus.$emit(Topics.NOTIFICATIONS, {
          message: 'Data final não informada',
          type: Types.WARNING,
        })
        return
      }

      if (!this.initialDate) {
        EventBus.$emit(Topics.NOTIFICATIONS, {
          message: 'Data inicial não informada',
          type: Types.WARNING,
        })
        return
      }

      if (new Date(this.initialDate) > new Date(this.finalDate)) {
        EventBus.$emit(Topics.NOTIFICATIONS, {
          message: 'Data inicial maior que a data final',
          type: Types.WARNING,
        })
        return
      }

      this.$emit('range', {
        initialDate: new Date(this.initialDate),
        finalDate: new Date(this.finalDate),
      })
    },
  },
}
</script>

<template>
  <div style="height: 70vh">
    <h1 class="md-title" style="color: black">Historico Epanet</h1>

    <div class="row">
      <div class="col-12">
        <h3 class="md-subheading">Data inicial</h3>
        <VueCtkDateTimePicker
          v-model="initialDate"
          :no-label="true"
          format="YYYY-MM-DD 00:00"
          formatted="LL"
        />
      </div>
      <div class="col-12">
        <h3 class="md-subheading">Data final</h3>
        <VueCtkDateTimePicker
          v-model="finalDate"
          :no-label="true"
          format="YYYY-MM-DD 23:59"
          formatted="LL"
        />
      </div>
    </div>

    <div class="mt-2" style="text-align: right">
      <md-button class="md-raised md-accent" @click="$emit('close')">
        Voltar
      </md-button>
      <md-button class="md-primary md-raised" @click="() => emitRange()">
        Usar
      </md-button>
    </div>
  </div>
</template>

<style scoped lang="scss"></style>
